var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.breadcrumbs
  }, [_c('div', {
    class: _vm.$style.path
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")]), _vm._l(_vm.breadcrumb, function (item, index) {
    return [index != 0 ? _c('span', {
      key: index
    }, [_c('span', {
      class: _vm.$style.arrow
    }), _c('span', [_vm._v(_vm._s(item.title))])]) : _vm._e()];
  }), _vm.activeItem ? _c('span', [_c('span', {
    class: _vm.$style.arrow
  }), _c('strong', {
    class: _vm.$style.current
  }, [_vm._v(_vm._s(_vm.activeItem.title))])]) : _vm._e()], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }